import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { json } from "utils/http/client";
import ContractorDetails from "./ContractorDetails";

const ContractorProfile = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [contractor, setContractor] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const orgId = JSON.parse(localStorage.getItem("organization"))?.id;
    if (!orgId) {
      setLoading(false);
      return;
    }

    const fetchContractor = async () => {
      try {
        const res = await json("/org/contractors/", {
          method: "POST",
          body: { organization_id: Number(orgId) },
        });
        const list = Array.isArray(res?.data)
          ? res.data
          : Array.isArray(res?.results)
          ? res.results
          : Array.isArray(res)
          ? res
          : [];
        const found = list.find((c) => String(c.id) === String(id));
        setContractor(
          found ? { ...found, contractor_type: found.work_name } : null
        );
      } catch (e) {
        setContractor(null);
      } finally {
        setLoading(false);
      }
    };

    fetchContractor();
  }, [id]);

  if (loading) return null;
  if (!contractor)
    return (
      <div className="bg-[#F5F5F5] text-[#737373] p-4">
        Contractor not found.
      </div>
    );

  return (
    <ContractorDetails
      contractor={contractor}
      onBack={() => navigate("/dashboard/contractor")}
    />
  );
};

export default ContractorProfile;
